// @owners { team: patients }
import { Button, Illustration } from '@alto/design-system';
import { CommsVerificationCard } from '@alto/features';
import * as React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { getImageAltText } from '~shared/assets/images/getImageAltText';
import { getCompanyName } from '~shared/config/getCompanyName';
import { useNavigateAfterVerification } from '../hooks/useNavigateAfterVerification';

type Props = {
  readonly authorized: boolean;
};

export const CommsVerificationInvalidChannel = ({ authorized }: Props) => {
  const navigateToNextRoute = useNavigateAfterVerification(authorized);

  return (
    <CommsVerificationCard
      headerIcon={
        <Illustration
          size="lg"
          source={getImage('alertIssue')}
          accessibilityLabel={getImageAltText('alertIssue')}
        />
      }
      title="Something went wrong"
      text="We are not able to verify the communication channel. Please try again or contact support."
      centerText
    >
      <Button
        onPress={navigateToNextRoute}
        label={`Continue to ${getCompanyName()}`}
        accessibilityLabel={`Continue to ${getCompanyName()}`}
        width="full"
      />
    </CommsVerificationCard>
  );
};
